/*
 * @描叙: 处理项目模型JSON结构 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-02-21 18:16:42 
*/

// 处理项目模板
    // 扁平数组转换成树形结构数据
export function translateDataToTree(data) {
    let parents = data.filter(value => value.parentId == 'undefined' || value.parentId == null)
    let children = data.filter(value => value.parentId !== 'undefined' && value.parentId != null)
    let translator = (parents, children) => {
        parents.forEach((parent) => {
            children.forEach((current, index) => {
                if (current.parentId === parent.id) {
                    let temp = JSON.parse(JSON.stringify(children))
                    temp.splice(index, 1)
                    translator([current], temp)
                    typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current]
                }
            }
            )
        }
        )
    }
    translator(parents, children)
    return parents
}

    // 树形结构数据换成扁平数组转
export function treeToPath(tree, path, currentPath) {
    currentPath = currentPath || [];
    path = path || [];
    for (let i = 0; i < tree.length; i++) {
        if (i !== 0) {
            currentPath.pop();
        }
        currentPath.push(tree[i]);
        if (tree[i].children && tree[i].children.length) {
            treeToPath(tree[i].children, path, currentPath);
        } else {
            path.push(currentPath.slice(0));
        }
    }
    currentPath.pop();
    return path;
}

// 数组扁平化处理 处理定时分类
export function flatten(data) {
    return data.reduce((arr, { label, pid, id, children = [] }) =>
        arr.concat([{ label, pid, id }], flatten(children)), [])
}

// 获取所有父级ID  处理定时分类
export function timerTypeIds(arr, id) {
    var newArr = [id];
    let flatArr = flatten(arr); //扁平素组
    var PID = flatArr.filter(v => { return v.id === id})
    if(PID.length<=0) return [id]
    function fn(data, pid) {
        data.map(v=>{
            if (pid === v.id) {
                newArr.push(v.id);
                fn(data, v.pid)
            }
        })
    }
    
    fn(flatArr, PID[0].pid);
    
    return newArr.reverse()
}

// 根据节点获取节点末端ID集合
export function timerChildrenIds(arr, id) {
    let ids = [];
    (function findCurrentNode(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
                fnAllLastNodeId(data[i].children, id)
                break;
            }
            if (data[i].children && data[i].children.length > 0) {
                findCurrentNode(data[i].children)
            }
        }
    })(arr)

    function fnAllLastNodeId(data) {
        if (!data) return ids.push(id);
        data.map(v => {
            if (v.children && v.children.length > 0) {
                fnAllLastNodeId(v.children)
            } else {
                ids.push(v.id)
            }
        })
    }
    return ids;
}

// 处理权限数据结构
    // 对象转数组   {"account":2,"project":2,"house":2,"business_owner":2,"collector":2,"terminal_device":2,"device_parameters":2,"device_control":2,"balance":2,"charge":2,"report":2,"time_control":2,"role_right":2}
    //  [{module_name:"account",module_value: '2'}]
export function fmtObjToArr(obj, roleModule) {
    if (JSON.stringify(roleModule)==="{}") return;
    let arr = [];
    obj.map(v=>{
        let key = v.K;
        if (roleModule[key]) {
            arr.push({
                ModuleKey: key,
                ModuleName: roleModule[key],
                Module_value: v.V,
            })
        }
    })
    return arr;
	
}

export function fmtArrToObj(arr) {
    return arr.map(v=>{
        return {
            K: v.ModuleKey,
            V: v.Module_value,
        }
    })
}

// 处理权限结构
    // 获取可读可操作权限表-----生成路由表
export function getRoles(role) {
    let arr = [];
    role.map(v => {
        if (v.V > 0) {
            arr.push(v.K)
        }
    })
 
    return arr
}

export function getEditRoles(role) {
    let obj = {}
    role.map(v => {
        let K = v.K
        obj[K] = v.V;
    })
    return obj
}

// 处理报警数据
export function noticeMsg(data) {
    if(data && data.length) {
        let arr = [];
        data.map(v => {
            let obj = {};
            obj.type = v.type;
            obj.status = v.status;
            obj.message = v.title;
            obj.terminal = v.data.terminal;
            obj.terminalInfo = v.data.data.data;
            arr.push(obj);
        })
        return arr;
    } else {
        return [];
    }
}